import { createContext, useContext } from 'react';

const defaultValues = {
  bevStatus: false,
  locationStrapiId: process.env.GATSBY_LOCATIONID,
  facilityName: '',
};
export const UnitAvailabilityContext = createContext<any>(defaultValues);
export const useUnitAvailabilityContext = () =>
  useContext(UnitAvailabilityContext);
